import getUid from './getUid';

export default function ensureId(feature) {
	if (!feature.getId()) {
		feature.setId(getUid(feature));
	}
}
